import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-df86b96c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popular-account" }
const _hoisted_2 = ["href", "onclick"]
const _hoisted_3 = { class: "hidden-xs" }
const _hoisted_4 = { class: "compare-column" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "openAccount" }, "OPEN ACCOUNT >", -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", null, [
      _createElementVNode("a", {
        href: _ctx.apyLink,
        onclick: _ctx.apyNavigation
      }, _toDisplayString(_ctx.$filters.percentageFilter(_ctx.popularAccount.Account.Apy)), 9, _hoisted_2)
    ]),
    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.productName), 1),
    _createElementVNode("td", _hoisted_4, [
      (_ctx.isAdAccount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.percentageFilter(_ctx.popularAccount.Ad.account.apy)), 1),
            _createTextVNode(" - "),
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.trackAdLink(_ctx.popularAccount.Ad)), ["prevent"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.accountDisplayName) + " ", 1),
              _hoisted_6
            ]),
            _createElementVNode("img", {
              class: "ad-pixel",
              width: "1",
              height: "1",
              alt: "",
              src: _ctx.$filters.formatTrackingFilter(_ctx.popularAccount.Ad.pixel)
            }, null, 8, _hoisted_7)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.percentageFilter(_ctx.popularAccount.NationalRate)), 1),
            _createTextVNode(" - "),
            _createElementVNode("a", {
              href: _ctx.popularAccount.Product.FullUrl
            }, "National Average", 8, _hoisted_9)
          ]))
    ])
  ]))
}